<template>
  <div class="card">
    <div>
      <h3>实验报告上传接口测试</h3>
      <p>filename</p>
      <input
        id="fileInfo"
        type="file"
        ref="fileInfo"
        style="width: 100%"
        class="s-input separate"
      >
      <p>originId：</p>
      <input
        type="text"
        v-model="formInfo.originId"
        style="width: 100%"
        class="s-input separate"
      >
      <p>Ticket：</p>
      <input
        type="text"
        v-model="formInfo.ticket"
        style="width: 100%"
        class="s-input separate"
      >
      <button
        class="s-btn"
        @click="doSubmit"
      >提交</button>
      <textarea
        v-model="formInfo.resultData"
        style="width: 100%; height: 100px"
        class="s-input separate"
      ></textarea>
      <div style="margin-bottom: 50px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperimentReportTest',
  data() {
    return {
      formInfo: {
        ticket: '3d337d7bcf3e85b85e8adeac36d21f93be673f********************************************e90cfb677d67c922a916738dc7e3f84db3db7d2ce',
        resultData: '',
        originId: '1234'
      }
    }
  },
  methods: {
    async doSubmit () {
      this.formInfo.resultData = ''
      const url = '/open/report_upload/?filename=' + this.$refs.fileInfo.files[0].name + '&originId=' + this.formInfo.originId + '&ticket=' + this.formInfo.ticket
      console.log(this.$refs.fileInfo.files[0])
      console.log(this.$refs.fileInfo.files[0].slice(0, 100))
      debugger
      await this.$http.post(url, this.$refs.fileInfo.files[0], {
        baseURL: ''
      }).then((data) => {
        this.formInfo.resultData = JSON.stringify(data)
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.account_table {
  width: 1200px;
  border: 1px solid #aaa;
}

.account_table tr td {
  border: 1px solid #aaa;
  padding: 5px;
}

.account_table tr td:first-child {
  width: 150px;
  background-color: #ddd;
  text-align: center;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.s-input {
  border: 1px solid #e6e6e6;
  border-right: none;
  background: #f5f7fc;
  height: 32px;
  /*line-height: 34px;*/
  padding-left: 10px;
  text-indent: 0;
  width: auto;
  border-radius: 2px;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
}

.s-btn {
  border: 1px solid #73D6CA;
  background: #73D6CA;
  height: 34px;
  line-height: 34px;
  text-align: center;
  color: #fff;
  padding: 0 12px;
  cursor: pointer;
  border-radius: 2px;
  vertical-align: middle;
  display: inline-block;
  margin-bottom: 10px;
  margin-top: 10px;
}

.desc {
  color: #777777;
}
</style>
